import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IGroupsState } from '../types';

const initialState: IGroupsState = {
  groups: [],
};

export const groupsSlice = createSlice({
  name: 'groups',
  initialState,
  reducers: {
    setGroups: (state, { payload }: PayloadAction<IGroupsState>) => {
      state.groups = payload.groups;
    },
  },
});

export const { setGroups } = groupsSlice.actions;
